import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuItem } from "@mui/material";

import { Paper,
  Typography,
  TextField,
  Button,
  Grid,
} from '@mui/material';
import bill from '../assets/bill.jpeg';
import logo from '../assets/log.png';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { Buffer } from 'buffer';
localStorage.clear();
const InvoiceGenerator = () => {
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
 
  const [isLoading, setIsLoading] = useState(false);
    const [clientDetails, setClientDetails] = useState({
      clientName: '',
      clientAddress: '',
      clientDistrict: '',
      clientPostalCode: '',
      clientCountry: '',
      clientAddNo: '',
      clientVatNumber: '',
      clientCRN: '',
      words:'',
    });
  
    const [invoiceDetails, setInvoiceDetails] = useState({
      invoiceDate: '',
      supplyDate: '',
      contractNo: '',
      invoicePeriod: '',
      projectRefNo: '',
    });
    const [products, setProducts] = useState([
      {
      
        unitRate: '',
        quantity: '',
        vatRate: '15.00',
        totalExclVAT: 0,
        vatAmount: 0,
        totalInclVAT: 0,
        translatedNatureOfGoods:'',
        
      },
    ]);
    const [example, setexample] = useState([
      {
        natureOfGoods: '',       // Nature of Goods input
    productDescription: '', 
  },
]);
const translations = {
  "Nature of Goods": "طبيعة البضائع",

  
  "Manpower":"قوى عاملة",
  "manpower":"قوى عاملة",
  "Kingdom of Saudi Arabia": "المملكة العربية السعودية",
  "Saudi Arabia": "المملكة العربية السعودية",
  "Kindom of Saudi Arabia": "المملكة العربية السعودية",
  "KSA": "المملكة العربية السعودية",
};

// Function to handle translation
function translate(text) {
// Normalize input by converting to lowercase
// Normalize input: convert to lowercase and trim spaces
const normalizedText = text.toLowerCase().trim();

// Find the translation by comparing normalized and trimmed keys
const foundTranslation = Object.keys(translations).find(
key => key.toLowerCase().trim() === normalizedText
);


// Return the translated value or the original text if not found
return foundTranslation ? translations[foundTranslation] : text;
};
    

    // Helper function to calculate the amounts for each product
    const calculateProductAmounts = (unitRate, quantity, vatRate) => {
      const totalExclVAT = (parseFloat(unitRate) || 0) * (parseFloat(quantity) || 0);
      const vatAmount = (totalExclVAT * (parseFloat(vatRate) || 0)) / 100;
      const totalInclVAT = totalExclVAT + vatAmount;
      return {
        totalExclVAT,
        vatAmount,
        totalInclVAT,
      };
    };
    const handleInputChange = (e, section) => {
      const { name, value } = e.target;
      if (section === 'client') {
        setClientDetails({ ...clientDetails, [name]: value });
      } else if (section === 'invoice') {
        setInvoiceDetails({ ...invoiceDetails, [name]: value });
      } };
    // Handle input change for products
    const handleProductChange = async(e, index) => {
      debugger
      const { name, value } = e.target;
      const updatedProducts = [...products];
      
      updatedProducts[index][name] = value;
  
      // Calculate the totals after the input change
      const { totalExclVAT, vatAmount, totalInclVAT } = calculateProductAmounts(
        updatedProducts[index].unitRate,
        updatedProducts[index].quantity,
        updatedProducts[index].vatRate
      );
  
      // Update the product with calculated amounts
      updatedProducts[index].totalExclVAT = totalExclVAT.toFixed(2);
      updatedProducts[index].vatAmount = vatAmount.toFixed(2);
      updatedProducts[index].totalInclVAT = totalInclVAT.toFixed(2);
  // Update the translated text based on the input
 
  setexample((prevProduct) => ({
    ...prevProduct,
    [name]: value,
  }));     // Update the state with the translated value
        setProducts(updatedProducts);
      
    };
  
    // Add a new product row
    const addProductRow = () => {
      setProducts((prevProducts) => [
        ...prevProducts,
        { natureOfGoods: '', unitRate: '', quantity: '', vatRate: '15.00', totalExclVAT: 0, vatAmount: 0, totalInclVAT: 0 },
      ]);
    };
  
    // Remove a product row
    const removeProductRow = (index) => {
      const updatedProducts = products.filter((_, i) => i !== index);
      setProducts(updatedProducts);
    };
  
    // Helper functions to calculate totals for all products
    const calculateTotalExclVAT = () => {
      return products.reduce((acc, product) => acc + parseFloat(product.totalExclVAT || 0), 0).toFixed(2);
    };
  
    const calculateTotalVAT = () => {
      return products.reduce((acc, product) => acc + parseFloat(product.vatAmount || 0), 0).toFixed(2);
    };
  
    const calculateTotalInclVAT = () => {
      return products.reduce((acc, product) => acc + parseFloat(product.totalInclVAT || 0), 0).toFixed(2);
    };
  
    const calculateBalanceDue = () => {
      return calculateTotalInclVAT(); // Assuming balance due is total including VAT
    };

   
  const generateTLV = (tag, value) => {
  const tagHex = tag.toString(16).padStart(2, '0');
  const lengthHex = value.length.toString(16).padStart(2, '0');
  const valueHex = Buffer.from(value).toString('hex');
  return tagHex + lengthHex + valueHex;
};

const getBillDetailsForQRCode = () => {
 const sellerName ="Rabie Development Contracting Est.";
  const vatRegistrationNumber = "311321306600003";
  const invoiceDate = invoiceDetails.invoiceDate || '';


  // Ensure totalInclVAT and vatAmount are numbers
  const totalAmount = products
    .reduce((acc, product) => acc + (parseFloat(product.totalInclVAT) || 0), 0)
    .toFixed(2);
  
  const vatAmount = products
    .reduce((acc, product) => acc + (parseFloat(product.vatAmount) || 0), 0)
    .toFixed(2);

  const tlvEncoded = 
    generateTLV(1, sellerName) +
    generateTLV(2, vatRegistrationNumber) +
    generateTLV(3, invoiceDate) +
    generateTLV(4, totalAmount) +
    generateTLV(5, vatAmount);

  return Buffer.from(tlvEncoded, 'hex').toString('base64');
};



    // Transliterate Latin to Arabic
    const transliterateToArabic = (text) => {
      if (!text || typeof text !== 'string') {
        return ''; // Return an empty string if text is undefined, null, or not a string
      }

      const transliterationMap = {
          'a': 'ا', 'b': 'ب', 'c': 'ك', 'd': 'د', 'e': 'ي', 'f': 'ف',
          'g': 'ج', 'h': 'ه', 'i': 'ي', 'j': 'ج', 'k': 'ك', 'l': 'ل',
          'm': 'م', 'n': 'ن', 'o': 'و', 'p': 'ب', 'q': 'ق', 'r': 'ر',
          's': 'س', 't': 'ت', 'u': 'و', 'v': 'ف', 'w': 'و', 'x': 'كس',
          'y': 'ي', 'z': 'ز',

          'A': 'ا', 'B': 'ب', 'C': 'ك', 'D': 'د', 'E': 'ي', 'F': 'ف',
          'G': 'ج', 'H': 'ه', 'I': 'ي', 'J': 'ج', 'K': 'ك', 'L': 'ل',
          'M': 'م', 'N': 'ن', 'O': 'و', 'P': 'ب', 'Q': 'ق', 'R': 'ر',
          'S': 'س', 'T': 'ت', 'U': 'و', 'V': 'ف', 'W': 'و', 'X': 'كس',
          'Y': 'ي', 'Z': 'ز',

          ' ': ' ', ',': '،', '.': '.',
      };

      return Array.from(text).map(char => transliterationMap[char] || char).join('');
  };
  
    
  // Helper function to convert numbers to words

    const translateText = async (text) => {
  
     console.log(text)
        try {
          const response = await axios.post('/arb', { text: text });
          if (response.status === 200) {
            console.log(response)
            return response.data.translated_text; // Return the translated text
          } else {
            throw new Error(`Failed to translate text. Status code: ${response.status}`);
          }
        } catch (error) {
          console.error('Error:', error);
        } finally {
          setIsLoading(false); // Hide loader
        }
      
      return text; // If no text or error, return the original text
    };
const printInvoice = async () => {
  // Convert productDescription to words if it's a number
  const translatedGoods = await translateText(example.natureOfGoods);
  const translatedDescription = await translateText(example.productDescription);
 

  const printWindow = window.open('', '', 'height=600,width=800');
  printWindow.document.write(`
    <html>
      <head>
        <title>Vat Invoice</title>
        <style>
     body {
         font-family: Arial, sans-serif;
         margin: 20px;
         padding: 20px;
     }
     table {
         width: 900px;
         border-collapse: collapse;
         margin-top: 20px;
         border: 1px solid black;
         margin-left: auto;
         margin-right: auto;
     }
     th, td {
         border: 1px solid black;
         padding: 1px;
         text-align: left;
         height: 20px; 
         line-height: 1; /* Adjust line height if needed */
     }
     th {
         background-color: #dadada;
     }
     .Invoice {
         text-align: center;
     }
     
     .invoice-title {
         text-align: center;
         font-size: 1.5rem;
         margin-bottom: 10px;
     }
     .bold {
         font-weight: bold;
     }
     .no-border {
         border: none;
     }
     .col1 {
         height: 40px;
         text-align: center;
     }
     .col2 {
         width: 140px; 
     }
     .col3 {
         height: 90px;
         text-align: center;
     }
     .col4 {
         width: 20%; 
     }
     .col5 {
         width: 24%; 
     }
     .col6 {
         width: 7%;
         text-align: center; 
     }
     .col7 {
         width: 23%; 
     }
     .col8 {
         width: 8%; 
     }
     .col9 {
         height: 30px;
     }
     .col10 {
         height: 30px;
         text-align: center;
     }
     .colgoods {
         width: 31%; 
     }
     .colQty {
         width: 4%;
         text-align: center; 
     }
     .collast{
         width: 20%;
     }
     .header-container {
         display: flex;
         justify-content: center;
         align-items: center;
         gap: 20px; /* Space between heading and logo */
     }
     .logo-container img {
         max-width: 100px; /* Adjust width as needed */
         height: auto;
     }
     .left-align {
         float: left;
     }
     .right-align {
         float: right;
         text-align: right; /* Ensures text is aligned to the right */
     }
     .clearfix::after {
         content: "";
         display: table;
         clear: both;
     }
     .Headtitle td {
         padding: 4px; 
         background-color: #648ec0;
     }

     .Headtitle h3 {
         margin: 0; 
         padding: 3px; 
         line-height: 1.2; 
         color: white;
     }
     p {
         margin: 0; 
     }
     .signature-section {
         text-align: center;
         vertical-align: bottom;
         padding-bottom: 10px;
     }
     .signature-section td {
         height: 60px;
     }
     .new{
         color: white;
         text-align: center; 
         background-color: #648ec0;
     }
     .qr-section {
         width: 20%;
         text-align: center;
         vertical-align: middle;
         border-left: 2px solid black;
     }
     .text-section {
         width: 30%;
         text-align: center;
         vertical-align: middle;
         border-left: 2px solid black;
     }
     
     .bold {
         font-weight: bold;
     }
     .arabic {
         font-size: 12px;
         display: block;
         font-family: 'Arial', sans-serif;
     }
     .align-end {
     text-align: right; /* Aligns text to the right */
     direction: rtl; /* Sets text direction to RTL */
 }

 @media print {
     * {
         -webkit-print-color-adjust: exact; 
         color-adjust: exact;               
         print-color-adjust: exact;         
     }
     body {
         margin: 0;
         padding: 0;
     }
 }
 </style>
</head>
<body>
 <div class="header-container">
     <div style="text-align: right;">
      <h1 style="color: #648ec0;">مؤسسة ربيع للتطوير للمقاولات</h1>
<h2 style="color: #648ec0;">Rabie Development Contracting Est.</h2>

     </div>
     <div class="logo-container">
       <img src=${bill} alt="Logo Image" /> 
   </div>
 </div>
 <div>
     <p class="Invoice"><strong>Vat Invoice:</strong></br><span class="bold">فاتورة ضريبة القيمة المضافة</span></p>
     <div class="clearfix">
         <p class="left-align" style="color: rgb(205, 0, 0);"><strong>Invoice No:</strong> <span class="bold">${invoiceNumber}</span></p>
         <p class="right-align" style="color: rgb(205, 0, 0);"><strong>رقم الفاتورة:</strong> <span class="bold">${invoiceNumber}</span></p>
     </div>
 </div>

 <table class="Detail">
        <tr class="Headtitle">
            <td colspan="8">
                <div class="clearfix">
                <h3 class="left-align"><strong><u>Our Details:</u></strong></h3>
                <h3 class="right-align" "dir="rtl"><strong><u>تفاصيلنا:</u></strong></h3>
                </div>
            </td>
        </tr>
       <tr>
    <th class="col2">Name:</th>
    <td colspan="3" class="col2">Rabie Development Contracting Est.</td>
    <td colspan="3" class="col2" style="text-align: end;"مؤسسة ربيع للتطوير للمقاولات</td>
    <th class="col2 align-end">الاسم:</th>
</tr>
<tr>
    <th class="col2">PO Box No:</th>
    <td colspan="3" class="col2"> 5078</td>
    <td colspan="3" class="col2"  style="text-align: end;"> 5078</td> 
    <th class="col2 align-end">صندوق البريد:</th>
</tr>
        <tr>
    <th class="col2">Building No:</th>
    <td class="col2">4834</td>
    <th class="col2">City:</th>
    <td>Ghab</td>
    <td style="text-align: end;">الغاب</td>
    <th class="col2 align-end">المدينة:</th>
    <td style="text-align: end;">4834</td>
    <th class="col2 align-end">رقم المبنى:</th>
</tr>

       <tr>
    <!-- English side -->
    <th class="col2">Secondary No:</th>
    <td>7211</td>
    <th class="col2">District:</th>
    <td>Safath jubail</td>

    <!-- Arabic side -->
    <td style="text-align: end;">صفاة الجبيل</td>
    <th class="col2 align-end">الحي:</th>
    <td style="text-align: end;">7211</td>
    <th class="col2 align-end">الرقم الثانوي:</th>
</tr>

        <tr>
            <th class="col2">Postal Code:</th>
            <td>66583</td>
            <th class="col2">Country:</th>
            <td>Kingdom of Saudi Arabia</td>
            <td style="text-align: end; width:10%;">المملكة العربية السعودية</td>
            <th class="col2 align-end"> الدولة:</th>
            <td style="text-align: end;">66583</td>
            <th class="col2 align-end">الرمز البريدي:</th>
        </tr>
        <tr>
            <th class="col2">Vat Number:</th>
            <td>311321306600003</td>
            <th class="col2">CRN:</th>
            
            <td colspan="2" style="text-align:center;">2055142395</td>
            <th class="col2 align-end"> السجل التجاري:</th>
            <td style="text-align: end;">311321306600003</td>
            <th class="col2 align-end">رقم ضريبة القيمة المضافة:</th>
        </tr>
    </table>




 
 <table class="Detail">
     <tr class="Headtitle">
         <td colspan="8" class="col2">
             <div class="clearfix">
             <h3 class="left-align"><strong><u>Client Details:</u></strong></h3>
             <h3 class="right-align" dir="rtl"><strong><u>تفاصيل العميل:</u></strong></h3>
             </div>
         </td>
     </tr>
     <tr>
         <th class="col2">Name:</th>
         <td colspan="3" class="col2">${clientDetails.clientName}</td>
         <td colspan="3" class="col2"  style="text-align: end;"> ${transliterateToArabic(clientDetails.clientName)}</td>
         <th class="col2 align-end">اسم:</th>
     </tr>
     <tr>
         <th class="col9">Address:</th>
         <td colspan="3" class="col9"> ${clientDetails.clientAddress}</td>
         <td colspan="3" class="col9"  style="text-align: end;"> ${transliterateToArabic(clientDetails.clientAddress)}</td> 
         <th class="col9 align-end">عنوان:</th>
     </tr>
    <tr>
         <th class="col2">Addl. No:</th>
         <td>${clientDetails.clientAddNo}</td>
         <th class="col2">District:</th>
         <td style="width : 10%;">${clientDetails.clientDistrict}</td>
         <td  style="text-align: end; width : 10%;">${transliterateToArabic(clientDetails.clientDistrict)}</td>
         <th class="col2 align-end">الحي:</th>
         <td  style="text-align: end;">${clientDetails.clientAddNo}</td>
         <th class="col2 align-end">الرقم الإضافي:</th>
     </tr>
     <tr>
         <th class="col2">Postal Code:</th>
         <td>${clientDetails.clientPostalCode}</td>
         <th class="col2">Country:</th>
         <td> ${clientDetails.clientCountry}</td>
         <td  style="text-align: end;">${translate(clientDetails.clientCountry)}</td>
         <th class="col2 align-end">دولة:</th>
         <td  style="text-align: end;">${transliterateToArabic(clientDetails.clientPostalCode)}</td>
         <th class="col2 align-end">الرمز البريدي:</th>
     </tr>
   <tr>
         <th class="col2">Vat Number:</th>
         <td>${clientDetails.clientVatNumber}</td>
         <th class="col2">CRN:</th>
         <td colspan="2" style="text-align:center;">${clientDetails.clientCRN}</td>
         <th class="col2 align-end">السجل التجاري:</th>
         <td  style="text-align: end;">${clientDetails.clientVatNumber}</td>
         <th class="col2 align-end">رقم ضريبة القيمة المضافة: </th>
     </tr>

 <table class="Detail">
     <tr>
         <th class="col1">  تاريخ الفاتورة <br>Invoice Date</th>
         
         <th class="col1">تاريخ التوريد <br>Supply Date</th>
         
         <th class="col1">   رقم العقد / أمر الشراء  <br>Contract/PO No</th>
        
         <th class="col1">  فترة الفاتورة <br>Invoice Period</th>
        
         <th class="col1"> رقم المشروع / المرجع  <br>Project/Reference No</th>
        
     </tr>
     <tr>
        <td class="col2" style="text-align: center;">
  ${invoiceDetails.invoiceDate ? new Date(invoiceDetails.invoiceDate).toLocaleDateString('en-GB') : ''}
</td>
<td class="col2" style="text-align: center;">
  ${invoiceDetails.supplyDate ? new Date(invoiceDetails.supplyDate).toLocaleDateString('en-GB') : ''}
</td>

         <td class="col2" style="text-align: center;">${invoiceDetails.contractNo}</td>
         <td class="col2" style="text-align: center;">${invoiceDetails.invoicePeriod}</td>
         <td class="col2" style="text-align: center;">${invoiceDetails.projectRefNo}</td>
     </tr>
 </table>

 <table class="Detail">
<thead>
 <tr>
   <th class="col3"> الإجمالي شامل الضريبة (ريال سعودي) <br>Total Incl. VAT (SAR):</th>
   <th class="col3"> مبلغ ضريبة القيمة المضافة (ريال سعودي) <br>VAT Amount (SAR):</th>
   <th class="col6"> نسبة الضريبة (%) <br>VAT %:</th>
   <th class="col3"> الإجمالي بدون ضريبة (ريال سعودي) <br>Total Excl. VAT (SAR):</th>
   <th class="col3"> سعر الوحدة (ريال سعودي)<br>Unit Rate (SAR):</th>
   <th class="col6"> الكمية <br>Qty <br> /Hours:</th>
   <th class="col3"> وحدة <br>Unit/Hour:</th>
   <th class="colgoods" style="text-align: center;"> طبيعة السلع/الخدمات <br>Nature of Goods/Services:(Description)</th>
   
   <th class="col6">#</th>
 </tr>
</thead>
<tbody>
 ${products.map((product, index) => `
   <tr>
     <td class="col1">${product.totalInclVAT}</td>
     <td class="col1">${product.vatAmount}</td>
     <td class="col1">${product.vatRate}</td>
     <td class="col1">${product.totalExclVAT}</td>
     <td class="col1">${product.unitRate}</td>
     <td class="col1">${product.quantity}</td>
     <td class="col1">${product.unit}</td>
     <td class="col1" id="translatedNatureOfGoods">${product.natureOfGoods} /${translatedGoods}
      <td class="col1">${index + 1}</td>
   </tr>
 `).join('')}
</tbody>
</table>

<!-- Summary Section -->
<table class="Summary">
<tr>
 <td class="col4">Total Excl. VAT (SAR):</td>
 <td class="col8">${calculateTotalExclVAT(products)}</td>
 <td class="col5">الإجمالي بدون ضريبة (ريال سعودي)</td>
 <td colspan="4" rowspan="2" class="text-section">
           
             ${example.productDescription}

         </td>
</tr>
<tr>
 <td class="col4">VAT Amount (SAR):</td>
 <td class="col8">${calculateTotalVAT(products)}</td>
 <td class="col5">مبلغ ضريبة القيمة المضافة (ريال سعودي)</td>
</tr>
<tr>
 <td class="col4">Total Incl. VAT (SAR):</td>
 <td class="col8">${calculateTotalInclVAT(products)}</td>
 <td class="col5">الإجمالي شامل الضريبة (ريال سعودي)</td>
 <td colspan="3" rowspan="2" class="signature-section">
         ${translatedDescription}
         </td>
</tr>
<tr>
 <td class="col4">Balance Due (SAR):</td>
 <td class="col8">${calculateBalanceDue(products)}</td>
 <td class="col5">الرصيد المستحق (ر.س)</td>
</tr>
</table>
 

 <table>
     <tr>
         <th colspan="4" class="new">Bank Details / التفاصيل المصرفية</th>
         <th colspan="2" class="new">Prepared By / معد الفاتورة</th>
         <th colspan="2" class="new">Received By / مستلم الفاتورة</th>
         <td rowspan="6" class="qr-section">
             <!-- QR Code Frame -->
             <div id="qrcode"></div>
             
         </td>
     </tr>
     <tr>
         <td colspan="2"><strong>ACCOUNT NAME</strong> / اسم الحساب</td>
         <td colspan="2" class="collast">
  Rabie Development Contracting Est.<br>
  مؤسسة ربيع للتطوير للمقاولات
</td>

         <td  rowspan="5" class="signature-section">
             <p style="font-size: 12px;">Signature with stamp</p><span class="arabic">التوقيع مع الختم</span>
         </td>
         <td colspan="3" rowspan="5" class="signature-section">
             <p style="font-size: 12px;">Signature with stamp</p><span class="arabic">التوقيع مع الختم</span>
         </td>
     </tr>
     <tr>
         <td colspan="2"><strong>BANK</strong> / بنك</td>
         <td colspan="2" class="collast">Al Rajhi bank</td>
     </tr>
     <tr>
         <td colspan="2"><strong>ACCOUNT</strong> / الحساب</td>
         <td colspan="2" class="collast">146000010006086556248</td>
     </tr>
     <tr>
         <td colspan="2"><strong>IBAN</strong> / ايبان</td>
         <td colspan="2" class="collast">SA0680000146608016556248</td>
         
     </tr>
     <tr>
         <td colspan="2"><strong></strong> </td>
         <td colspan="2" class="collast"></td>
     </tr>
 </table>

</body>

           <!-- QR Code Section -->
           <div class="qr-code">
             <!--h3>Scan QR Code for Bill Details</h3>
             <div id="qrcode"></div-->
           </div>
         </div>
        <script>
           const qrcode = document.getElementById('qrcode');
           const qrCodeData =  '${getBillDetailsForQRCode()}';
             
           const qrCodeImage = 'https://api.qrserver.com/v1/create-qr-code/?data=' + encodeURIComponent(qrCodeData) + '&size=150x150';
           const imgElement = document.createElement('img');
           imgElement.src = qrCodeImage;
           qrcode.appendChild(imgElement);
         </script>-
       </body>
     </html>
 

 
   `);
   printWindow.document.close();
   printWindow.print();
   const newInvoiceNumber = invoiceNumber + 1;
      setInvoiceNumber(newInvoiceNumber);
      localStorage.setItem('invoiceNumber', newInvoiceNumber);
      };
   
// Load the last invoice number from localStorage when the component mounts
useEffect(() => {
  const fetchNextInvoiceNumber = async () => {
    try {
      const response = await axios.get('https://rabiebillsaudi.onrender.com/api/invoice/next-invoice-number');
      if (response.status === 200) {
        setInvoiceNumber(response.data.nextInvoiceNumber);
      } else {
        console.error('Failed to fetch invoice number:', response);
      }
    } catch (error) {
      console.error('Error fetching next invoice number:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchNextInvoiceNumber();
}, []);

const handleSubmit = async () => {
  if (!invoiceNumber || isNaN(invoiceNumber)) {
    alert('Invoice number is invalid. Please refresh the page.');
    return;
  }

  const payload = {
    invoiceNumber,
    clientDetails,
    invoiceDetails,
    products: products.map((product) => ({
      natureOfGoods: product.natureOfGoods,
      unitRate: product.unitRate,
      quantity: product.quantity,
      vatRate: product.vatRate,
      totalExclVAT: product.totalExclVAT,
      vatAmount: product.vatAmount,
      totalInclVAT: product.totalInclVAT,
      unit: product.unit, // Include Unit/Hour
      productDescription: product.productDescription, // Include Final Amount in Words
    })),
    totals: {
      totalExclVAT: calculateTotalExclVAT(),
      totalVAT: calculateTotalVAT(),
      totalInclVAT: calculateTotalInclVAT(),
      balanceDue: calculateBalanceDue(),
    },
  };

  try {
    const response = await axios.post('https://rabiebillsaudi.onrender.com/api/invoice', payload);
    if (response.status === 201) {
      alert('Invoice submitted successfully!');
    } else {
      alert('Failed to submit invoice.');
    }
  } catch (error) {
    console.error('Error submitting invoice:', error);
    alert(error.response?.data?.error || 'An error occurred while submitting the invoice.');
  }
};

      
    
 return (
  <>
    <Paper
      style={{
        padding: 30,
        margin: "30px auto",
        maxWidth: 1000,
        backgroundColor: "#ffffff",
        borderRadius: "20px",
        border: "2px solid #004D46", // teal from your swatch
        boxShadow: "0px 8px 25px rgba(0,0,0,0.08)",
      }}
    >
      {/* Keep logo exactly as-is */}
      <img
        src={logo}
        alt="Logo"
        style={{
          display: "block",
          margin: "0 auto",
          maxWidth: "100%",
          height: "auto",
        }}
      />

      <div dir="rtl">
        {/* Main Heading */}
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          style={{ marginBottom: 30, fontWeight: "bold", color: "#004D46" }}
        >
          Invoice Generator
        </Typography>

        {/* Our Details Section */}
        <Typography
          variant="h6"
          gutterBottom
          align="center"
          style={{
            marginBottom: 20,
            fontWeight: "bold",
            color: "#004D46",
            borderBottom: "3px solid #004D46",
            display: "inline-block",
          }}
        >
          Our Details
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Name"
              value="Rabie Development Contracting Est."
              InputProps={{ readOnly: true }}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>

          {/* Company details */}
          {[
            { label: "Post Box No", value: "5078" },
            
            { label: "Building No", value: "4834" },
            { label: "City", value: "Ghab" },
            
            { label: "Country", value: "Kingdom of Saudi Arabia" },
            { label: "Postal Code", value: "11564" },
            { label: "VAT Number", value: "311321306600003" },
            { label: "CRN", value: "2055142395" },
          ].map((f, i) => (
            <Grid item xs={4} key={i}>
              <TextField
                label={f.label}
                value={f.value}
                InputProps={{ readOnly: true }}
                fullWidth
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    "& fieldset": { borderColor: "#004D46" },
                    "&:hover fieldset": { borderColor: "#004D46" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#004D46",
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#004D46",
                    fontWeight: "600",
                  },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
                }}
              />
            </Grid>
          ))}
        </Grid>

        {/* Client Details Section */}
        <Typography
          variant="h6"
          gutterBottom
          align="center"
          style={{
            margin: "30px 0 20px 0",
            fontWeight: "bold",
            color: "#004D46",
            borderBottom: "3px solid #004D46",
            display: "inline-block",
          }}
        >
          Client Details
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              label="Name"
              name="clientName"
              value={clientDetails.clientName}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Address"
              name="clientAddress"
              value={clientDetails.clientAddress}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="District"
              name="clientDistrict"
              value={clientDetails.clientDistrict}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Postal Code"
              name="clientPostalCode"
              value={clientDetails.clientPostalCode}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Country"
              name="clientCountry"
              value={clientDetails.clientCountry}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Addl. No"
              name="clientAddNo"
              value={clientDetails.clientAddNo}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="VAT Number"
              name="clientVatNumber"
              value={clientDetails.clientVatNumber}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="CRN"
              name="clientCRN"
              value={clientDetails.clientCRN}
              onChange={(e) => handleInputChange(e, "client")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
        </Grid>

        {/* Invoice Details Section */}
        <Typography
          variant="h6"
          gutterBottom
          align="center"
          style={{
            margin: "30px 0 20px 0",
            fontWeight: "bold",
            color: "#004D46",
            borderBottom: "3px solid #004D46",
            display: "inline-block",
          }}
        >
          Invoice Details
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              label="Invoice Number"
              value={loading ? "Loading..." : invoiceNumber || 100}
              InputProps={{ readOnly: true }}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Invoice Date"
              type="date"
              name="invoiceDate"
              value={invoiceDetails.invoiceDate}
              onChange={(e) => handleInputChange(e, "invoice")}
              fullWidth
              InputLabelProps={{ shrink: true }}
              placeholder="dd-mm-yyyy"
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Supply Date"
              type="date"
              name="supplyDate"
              value={invoiceDetails.supplyDate}
              onChange={(e) => handleInputChange(e, "invoice")}
              fullWidth
              InputLabelProps={{ shrink: true }}
              placeholder="dd-mm-yyyy"
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Contract / PO No"
              name="contractNo"
              value={invoiceDetails.contractNo}
              onChange={(e) => handleInputChange(e, "invoice")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Invoice Period"
              name="invoicePeriod"
              value={invoiceDetails.invoicePeriod}
              onChange={(e) => handleInputChange(e, "invoice")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Project / Reference No"
              name="projectRefNo"
              value={invoiceDetails.projectRefNo}
              onChange={(e) => handleInputChange(e, "invoice")}
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "& fieldset": { borderColor: "#004D46" },
                  "&:hover fieldset": { borderColor: "#004D46" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#004D46",
                    borderWidth: 2,
                  },
                },
                "& .MuiInputLabel-root": { color: "#004D46", fontWeight: "600" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
              }}
            />
          </Grid>
        </Grid>

        {/* Products Section */}
        <Typography
          variant="h6"
          gutterBottom
          align="center"
          style={{
            margin: "30px 0 20px 0",
            fontWeight: "bold",
            color: "#004D46",
            borderBottom: "3px solid #004D46",
            display: "inline-block",
          }}
        >
          Products
        </Typography>

        {products.map((product, index) => (
          <Paper
            key={index}
            elevation={0}
            style={{
              marginBottom: "20px",
              padding: "16px",
              borderRadius: "16px",
              border: "1px solid #e7e7e7",
              position: "relative",
            }}
          >
            {/* teal corner accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                width: 20,
                height: 20,
                backgroundColor: "#004D46",
                borderTopRightRadius: "16px",
                borderBottomLeftRadius: "8px",
              }}
            />
            <Typography
              variant="subtitle1"
              style={{ fontWeight: 700, color: "#004D46", marginBottom: 8 }}
            >
              Product {index + 1}
            </Typography>

            <Grid container spacing={2}>
              {/* Nature of Goods Input */}
              <Grid item xs={4}>
                <TextField
                  type="text"
                  name="natureOfGoods"
                  value={product.natureOfGoods}
                  onChange={(e) => handleProductChange(e, index)}
                  placeholder="Nature of Goods"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { borderColor: "#004D46" },
                      "&:hover fieldset": { borderColor: "#004D46" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#004D46",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#004D46",
                      fontWeight: "600",
                    },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
                  }}
                />
              </Grid>

              {/* Unit Rate Input */}
              <Grid item xs={4}>
                <TextField
                  type="number"
                  name="unitRate"
                  value={product.unitRate}
                  onChange={(e) => handleProductChange(e, index)}
                  placeholder="Unit Rate"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { borderColor: "#004D46" },
                      "&:hover fieldset": { borderColor: "#004D46" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#004D46",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#004D46",
                      fontWeight: "600",
                    },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
                  }}
                />
              </Grid>

              {/* Empty placeholder to keep grid shape as in your code */}
              <Grid item xs={4} />

              {/* Quantity */}
              <Grid item xs={4}>
                <TextField
                  type="number"
                  name="quantity"
                  value={product.quantity}
                  onChange={(e) => handleProductChange(e, index)}
                  placeholder="Quantity"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { borderColor: "#004D46" },
                      "&:hover fieldset": { borderColor: "#004D46" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#004D46",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#004D46",
                      fontWeight: "600",
                    },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
                  }}
                />
              </Grid>

              {/* Unit select */}
              <Grid item xs={4}>
                <TextField
                  select
                  name="unit"
                  value={product.unit}
                  placeholder="Unit/Hour"
                  onChange={(e) => handleProductChange(e, index)}
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { borderColor: "#004D46" },
                      "&:hover fieldset": { borderColor: "#004D46" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#004D46",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#004D46",
                      fontWeight: "600",
                    },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
                  }}
                >
                  <MenuItem value="UNIT">UNIT</MenuItem>
                  <MenuItem value="HOURLY">HOURLY</MenuItem>
                </TextField>
              </Grid>

              {/* VAT Percentage */}
              <Grid item xs={4}>
                <TextField
                  type="number"
                  name="vatRate"
                  value={product.vatRate}
                  onChange={(e) => handleProductChange(e, index)}
                  placeholder="VAT Rate"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { borderColor: "#004D46" },
                      "&:hover fieldset": { borderColor: "#004D46" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#004D46",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#004D46",
                      fontWeight: "600",
                    },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
                  }}
                />
              </Grid>

              {/* Total Amount In Words */}
              <Grid item xs={6}>
                <TextField
                  label="Final Amount In Words"
                  type="text"
                  name="productDescription"
                  value={product.productDescription}
                  onChange={(e) => handleProductChange(e, index)}
                  placeholder="Enter the Final Amount"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { borderColor: "#004D46" },
                      "&:hover fieldset": { borderColor: "#004D46" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#004D46",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#004D46",
                      fontWeight: "600",
                    },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#004D46" },
                  }}
                />
              </Grid>
            </Grid>

            {/* Display Calculated Totals */}
            <div style={{ marginTop: 10, color: "#004D46", fontWeight: 600 }}>
              <p>Total Excl. VAT: {product.totalExclVAT} SAR</p>
              <p>VAT Amount: {product.vatAmount} SAR</p>
              <p>Total Incl. VAT: {product.totalInclVAT} SAR</p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "10px 0",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                style={{ backgroundColor: "#c62828", borderRadius: 12 }}
                onClick={() => removeProductRow(index)}
              >
                <DeleteIcon />
              </Button>
            </div>
          </Paper>
        ))}

        {/* Add product row button */}
        <Button
          variant="contained"
          color="primary"
          onClick={addProductRow}
          style={{
            margin: "20px 0",
            backgroundColor: "#004D46",
            borderRadius: "28px",
            padding: "10px 24px",
            fontWeight: 700,
          }}
        >
          Add Product
        </Button>

        {/* Totals for all products */}
        <Paper
          elevation={0}
          style={{
            marginTop: 20,
            padding: 16,
            borderRadius: 16,
            border: "1px solid #e7e7e7",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: 20,
              height: 20,
              backgroundColor: "#004D46",
              borderTopRightRadius: "16px",
              borderBottomLeftRadius: "8px",
            }}
          />
          <Typography variant="h6" style={{ fontWeight: "bold", color: "#004D46" }}>
            Totals
          </Typography>
          <p>Total Excl. VAT: {calculateTotalExclVAT()} SAR</p>
          <p>Total VAT: {calculateTotalVAT()} SAR</p>
          <p>Total Incl. VAT: {calculateTotalInclVAT()} SAR</p>
          <p>Balance Due: {calculateBalanceDue()} SAR</p>
        </Paper>

        {/* Actions */}
        <div style={{ textAlign: "center", marginTop: 30 }}>
          {/* Translate */}
          <div>
            <Button
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#004D46",
                padding: "15px 30px",
                fontSize: "18px",
                borderRadius: "30px",
                marginBottom: "20px",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Translating..." : "Translate"}
            </Button>
          </div>

          {/* Print & Help */}
          <div>
            <Button
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#004D46",
                padding: "10px 20px",
                fontSize: "16px",
                width: "150px",
                marginRight: "10px",
                borderRadius: "25px",
              }}
              onClick={() => {
    handleSubmit();
    printInvoice();
  }}
              disabled={isLoading}
            >
              Print
            </Button>

            <Button
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#007bff",
                padding: "10px 20px",
                fontSize: "16px",
                width: "150px",
                borderRadius: "25px",
              }}
              onClick={() =>
                window.open(
                  "https://wa.me/919486042369?text=Hello, I need help with...",
                  "_blank"
                )
              }
            >
              Help
            </Button>
          </div>
        </div>

        {/* Submit Button */}
        
      <div
    style={{
      marginTop: "50px",
      fontSize: "15px",
      color: "#004D46",
      fontWeight: "bold",
      textAlign: "right",
      fontFamily: "Arial, sans-serif",
    }}
  >
    📧 info@rabiecontract.com
  </div>
      </div>
    </Paper>

    {/* VIEW LIST BUTTON (kept outside main Paper) */}
    <div style={{ textAlign: "right", margin: 20 }}>
      <div className="absolute top-4 right-4">
        <button
          className="bg-[#004D46] hover:bg-[#00695c] text-white py-2 px-4 text-base w-[150px] rounded"
          onClick={() => navigate("/list")}
        >
          View List
        </button>
      </div>
    </div>
  </>
);

};

export default InvoiceGenerator;